export interface FieldOkConfiguration {
  title?: string | null;
  subtitle?: string | null;
}

export type DefaultFieldOkConfiguration = FieldOkConfiguration;
